import { isEmpty } from 'underscore';
import { withValidation, withError, AdapterFactory } from '@bingads-webui-react/validation';
import { LanguageTarget, SingleLanguageTarget } from '@bingads-webui-campaign-react/language-target';

const LanguageTargetValidationAdapter = AdapterFactory({
  defaultValue: [],
  valueToInject: 'selectedLanguages',
  functionToInject: 'setSelectedLanguages',
});

export const LanguageTargetValidatorFactory = i18n => function LanguageTargetValidator(value, defaultValidator) {
  const defaultErrors = defaultValidator(value);
  return [
    ...isEmpty(defaultErrors) ? [] : defaultErrors,
    ...value.length < 1 ? [i18n.getString(_TL_('Select at least one language'))] : [],
  ];
};

export const SingleLanguageTargetValidator = (value, defaultValidator) => {
  if (value === null || value === undefined) {
    return [];
  }
  return defaultValidator(value);
};

const SingleLanguageTargetValidationAdapter = AdapterFactory({
  defaultValue: 'None',
  valueToInject: 'selectedLanguage',
  functionToInject: 'setSelectedLanguage',
});

export const ValidatedLanguageTarget = withError(withValidation(LanguageTarget, LanguageTargetValidationAdapter));

export const ValidatedSingleLanguageTarget = withError(withValidation(SingleLanguageTarget, SingleLanguageTargetValidationAdapter));
